/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ViewInRoomImage_item = {
    readonly measurement: {
        readonly convertedMeasurements: {
            readonly width: string | null;
        } | null;
    } | null;
    readonly " $refType": "ViewInRoomImage_item";
};
export type ViewInRoomImage_item$data = ViewInRoomImage_item;
export type ViewInRoomImage_item$key = {
    readonly " $data"?: ViewInRoomImage_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "kind": "LinkedField",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemConvertedMeasurementsType",
          "kind": "LinkedField",
          "name": "convertedMeasurements",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '325ee56942b666d70455a66c019ec980';
export default node;
